import './LanguageSwitcher.scss'
import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router'
import { useLanguage } from '#src/hooks/useLanguage.js'
import { LANGUAGE_NAMES, languageService, SUPPORTED_LANGUAGES } from '#src/languageService.js'

interface LanguageSwitcherProps {
  className?: string
}

export function LanguageSwitcher(props: LanguageSwitcherProps = {}): ReactNode {
  const { pathname } = useLocation()
  const active = useLanguage()
  // The same page, viewed in each language - navigating swaps the URL prefix.
  const canonical = languageService.delocalizePath(pathname)

  return (
    <div className={`lang-switcher${props.className ? ` ${props.className}` : ''}`}>
      {SUPPORTED_LANGUAGES.map(l => (
        <Link
          key={l}
          to={languageService.localizePath(canonical, l)}
          className={`lang-switcher__btn${l === active ? ' lang-switcher__btn_active' : ''}`}
          aria-current={l === active ? 'true' : undefined}
          // Remember the explicit choice (same key as first-visit detection), so
          // home auto-detection won't override it on a later visit.
          onClick={() => languageService.setStoredLanguage(l)}
        >
          {LANGUAGE_NAMES[l]}
        </Link>
      ))}
    </div>
  )
}
